import logo from './logo.svg';
import './App.css';
import AllRoutes from './components/AllRoutes/AllRoutes';

function App() {
  return (
    <div className="App">
      <AllRoutes />
    </div>
  );
}

export default App;
